var map = {
	"./Add.svg": 80184,
	"./Apoteket.svg": 32270,
	"./Apoterkset.svg": 23661,
	"./Authenticated.svg": 49372,
	"./AuthenticationFailed.svg": 42956,
	"./AuthenticationFailedRegister.svg": 62079,
	"./AuthenticationHistory.svg": 49813,
	"./AuthenticationSuccessRegister.svg": 18411,
	"./BackTo.svg": 97137,
	"./BackToGreen.svg": 88110,
	"./Blue.svg": 5579,
	"./CallbackRequests.svg": 34964,
	"./CallerAuthentication.svg": 39590,
	"./Capacity.svg": 68215,
	"./ChangePassword.svg": 23740,
	"./Check.svg": 50913,
	"./Checkmark.svg": 49618,
	"./ChooseTime.svg": 79183,
	"./Close.svg": 68285,
	"./CloseInput.svg": 35063,
	"./CloseModal.svg": 60520,
	"./CloseValue.svg": 4324,
	"./CustomersFeedback.svg": 30235,
	"./Delete.svg": 73170,
	"./Down.svg": 91595,
	"./DownImg.svg": 2600,
	"./DownloadBlack.svg": 18556,
	"./Edit.svg": 60207,
	"./EditGreen.svg": 52620,
	"./Error.svg": 70559,
	"./FlagEnglish.svg": 16563,
	"./Fridge.svg": 23408,
	"./Gray.svg": 29626,
	"./Green.svg": 7296,
	"./Hyphen.svg": 71463,
	"./Logout.svg": 20485,
	"./MarkAsDone.svg": 99284,
	"./MarkAsMissed.svg": 63503,
	"./Orange.svg": 81669,
	"./Order.svg": 57841,
	"./OrdersHistory.svg": 16952,
	"./PaymentNotificationWasSuccessfullyResend.svg": 29879,
	"./Pharmacies.svg": 28132,
	"./PickedUpReservation.svg": 17746,
	"./PickupBox.svg": 24034,
	"./PickupBoxes.svg": 78170,
	"./Profile.svg": 67118,
	"./Qr-code.svg": 2168,
	"./Red.svg": 90112,
	"./SMS.svg": 88114,
	"./Search.svg": 87639,
	"./SeeValue.svg": 75063,
	"./Sensors.svg": 7172,
	"./Settings.svg": 32140,
	"./SocialSecurityNumber.svg": 98347,
	"./UserGuide.svg": 83026,
	"./Users.svg": 27733
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46669;